import { AffiliatesScreen } from '@features/affiliates'

export function AfiliadosPage({ inviteToken }: { inviteToken?: string }) {
  return <AffiliatesScreen inviteToken={inviteToken} />
}
